import React from 'react';
import { StyledButtonExternalLink } from './styles';
import { ButtonExternalLinkProps } from './types';
import { ButtonKind, ButtonMode, ButtonSize } from './enums';

const modeToKind: Record<ButtonMode, ButtonKind> = {
  [ButtonMode.Primary]: ButtonKind.Primary,
  [ButtonMode.Secondary]: ButtonKind.Outline,
  [ButtonMode.Tertiary]: ButtonKind.Danger,
  [ButtonMode.Info]: ButtonKind.Soft,
};

const ButtonExternalLink: React.FC<ButtonExternalLinkProps> = ({
  mode = ButtonMode.Primary,
  kind: kindProp,
  size = ButtonSize.Big,
  icon: Icon,
  children,
  ...props
}) => {
  const kind = kindProp ?? modeToKind[mode];
  const buttonTextVariant = size === ButtonSize.Big ? 'body' : 'caption';

  return (
    <StyledButtonExternalLink
      variant={buttonTextVariant}
      {...{ kind, size, ...props }}
    >
      {Icon && <Icon />}
      {children}
    </StyledButtonExternalLink>
  );
};

export default ButtonExternalLink;
